
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(23 3)","stroke-width":"6","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"x":"13","width":"28","height":"64","rx":"14"}}),_c('path',{attrs:{"d":"M0 43v6.403C0 64.093 12.088 76 27 76s27-11.908 27-26.597V43M27 93.503V76.5M9 94h36"}})])])
          )
        }
      }
    